<template>
  <div class="uk-height-1-1" style="margin-top: -80px">
    <div
      class="uk-cover-container"
      uk-height-viewport="offset-bottom: 10"
    >
      <img src="@/assets/images/main-header.png" alt="" uk-cover>
      <div class="uk-overlay uk-overlay-primary uk-position-cover">
        <div class="uk-position-bottom-center">
          <div class="header-texts">
            <h1 class="uk-heading-xlarge uk-margin-auto">
              Jason <br class="uk-hidden@m">de Ridder
            </h1>
            <h2 class="uk-margin-remove-top">Voice-Over <br class="uk-hidden@m">& Stemacteur</h2>
          </div>
          <div class="play-icon uk-align-center">
              <play-button-header
                class="uk-margin-auto uk-display-block uk-width-auto"
                :audio-file="require('@/assets/audio/Jason_de_ridder_compilatie.mp3')"
                audio-name="general-demo"/>
          </div>
          <USPMarquee>
            <USP>Binnen 24 uur geleverd</USP>
            <USP>Professioneel acteur</USP>
            <USP>Niet goed? Opnieuw!</USP>
            <USP>Al vanaf € 29,-</USP>
          </USPMarquee>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayButtonHeader from '@/components/PlayButtonHeader.vue';
import USPMarquee from '@/components/USPMarquee.vue';
import USP from '@/components/USP.vue';

export default {
  name: 'MainHeader.vue',
  components: {
    PlayButtonHeader,
    USPMarquee,
    USP,
  },
};
</script>
